/**
 * The appearance-mode select used by General.
 *
 * @module
 */
import { Theme } from "../../hooks/useTheme";
import { Select, SelectItem, SelectPopup, SelectTrigger, SelectValue } from "../ui/select";
import { ReactNode } from "react";

const THEME_LABELS: Readonly<Record<Theme, string>> = {
  system: "System",
  light: "Light",
  dark: "Dark",
};

export const SETTINGS_THEME_OPTIONS = [
  "system",
  "light",
  "dark",
] as const satisfies readonly Theme[];

function isSettingsThemeOption(value: unknown): value is Theme {
  return SETTINGS_THEME_OPTIONS.some((option) => option === value);
}

export function ThemeSelectControl(props: {
  readonly theme: Theme;
  readonly onThemeChange: (theme: Theme) => void;
}): ReactNode {
  return (
    <Select
      value={props.theme}
      onValueChange={(value) => {
        if (isSettingsThemeOption(value)) {
          props.onThemeChange(value);
        }
      }}
    >
      <SelectTrigger className="w-full sm:w-40" aria-label="Theme">
        <SelectValue>{THEME_LABELS[props.theme]}</SelectValue>
      </SelectTrigger>
      <SelectPopup align="end" alignItemWithTrigger={false}>
        {SETTINGS_THEME_OPTIONS.map((option) => (
          <SelectItem key={option} hideIndicator value={option}>
            {THEME_LABELS[option]}
          </SelectItem>
        ))}
      </SelectPopup>
    </Select>
  );
}
